// src/app/state/reducers/side-menu.reducer.ts

import { createReducer, on } from '@ngrx/store';
import * as SideMenuActions from '../actions/side-menu.actions';

export const initialState = "visible";

export const sideMenuReducer = createReducer(
  initialState,
  on(SideMenuActions.toggleSideMenu, state => {
    return state === "visible" ? "collapsed" : "visible";
  })
);

